$('.js-closeCheckProfile').on('click', (event) => {
  $(event.currentTarget).parent().remove()
})
